module.exports = __webpack_public_path__ + "img/about-us-1.8a981098.png";